"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveEventStreamSerdeConfig = void 0;

var tslib_1 = require("tslib");

function resolveEventStreamSerdeConfig(input) {
  return tslib_1.__assign(tslib_1.__assign({}, input), {
    eventStreamMarshaller: input.eventStreamSerdeProvider(tslib_1.__assign({}, input))
  });
}

exports.resolveEventStreamSerdeConfig = resolveEventStreamSerdeConfig;